export default __webpack_public_path__ + "../staticImages/sprite-mastercard-2x.png";